import { styled, useTheme } from '@mui/material';
import { Typography } from '../../../../../../../components/Typography/Typography';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 632px;
`;

interface Props {
  name: string;
}

export const ObjectiveName = ({ name }: Props) => {
  const { colors } = useTheme();
  return (
    <Container>
      <Typography
        variant='overline'
        color={colors.primary[70]}
        style={{ textTransform: 'uppercase' }}
      >
        Objective
      </Typography>
      <Typography variant='subtitle2' color={colors.primary[90]}>
        {name}
      </Typography>
    </Container>
  );
};
